import { DateTime } from 'luxon';
import { ExternalCalendarEventSummary } from '../types';

const isBookedExternally = (
  eventStart: DateTime,
  eventEnd: DateTime,
  externalEvents: ExternalCalendarEventSummary[]
) => {
  const now = DateTime.now();
  if (now.isInDST && !eventStart.isInDST) {
    return externalEvents.some(
      (ee) =>
        DateTime.fromISO(ee.endDate).minus({ hours: 1 }) > eventStart &&
        DateTime.fromISO(ee.startDate).minus({ hours: 1 }) < eventEnd
    );
  }

  if (!now.isInDST && eventStart.isInDST) {
    return externalEvents.some(
      (ee) =>
        DateTime.fromISO(ee.endDate).plus({ hours: 1 }) > eventStart &&
        DateTime.fromISO(ee.startDate).plus({ hours: 1 }) < eventEnd
    );
  }
  return externalEvents.some(
    (ee) =>
      DateTime.fromISO(ee.endDate) > eventStart &&
      DateTime.fromISO(ee.startDate) < eventEnd
  );
};

export default isBookedExternally;
